module.exports = __webpack_public_path__ + "assets/img/youer-bc655881.png";